module.exports = __webpack_public_path__ + "img/img_new_top3.28582c4c.png";